import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import style from '../../../style/components/profile/emails/EmailDefaultBadge.module.scss';

const EmailDefaultBadge = () => {
  const { t } = useTranslation();

  return <span className={style.badge}>{t('walletEmails.badgeDefault')}</span>;
};

export default memo(EmailDefaultBadge);
